import { ArrowRightIcon } from '@heroicons/react/20/solid'
import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Customer } from '../../../gql/graphql'
import { FESTIVAL_SELECTION_PATH } from '../../_lib/festival'
import { Dialog } from '../../_ui/Dialog'
import { useFestival } from '../FestivalContext'
import { FestivalOption } from './components/FestivalOption'

type PropTypes = {
  open: boolean
  onClose: () => void
}

export const SwitchFestivalDialog = ({ open, onClose }: PropTypes) => {
  const { festival: currentFestival, festivals, selectFestival } = useFestival() || {}

  const handleSelect = useCallback((festival: Customer) => {
    if (festival.id === currentFestival?.id) {
      onClose()
      return
    }

    selectFestival?.(festival.id)
    onClose()
  }, [currentFestival?.id, onClose, selectFestival])

  return (
    <Dialog
      title={'Festival wechseln'}
      open={open}
      onClose={onClose}
    >
      <div className={'grid grid-cols-1 gap-3'}>
        {(festivals || []).map(festival => (
          <FestivalOption
            key={festival.id}
            festival={festival}
            isCurrent={festival.id === currentFestival?.id}
            onSelect={handleSelect}
          />
        ))}
        <Link
          to={FESTIVAL_SELECTION_PATH}
          onClick={onClose}
          className={'mt-2 flex items-center justify-center gap-1.5 rounded-lg border-t border-gray-100 pt-4 text-sm font-medium text-primary-300 hover:text-primary-400'}
        >
          Weitere Festivals entdecken
          <ArrowRightIcon className={'h-4 w-4'} />
        </Link>
      </div>
    </Dialog>
  )
}
